module.exports = __webpack_public_path__ + "media/images/responsive/lp/clean/promise_06_sp-2c925138643244229303d8f35adc277b.png";